import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const FragranceSection = (): ReactElement => {
  const { t: tFragrance } = useTranslation('', { keyPrefix: '$local.$fragranceSection' });
  const { t: tLinks } = useTranslation('', {
    keyPrefix: '$local.$homePageLinks.$fragranceSection',
  });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  return (
    <section className="base-section fragrance-section hp-section">
      {/* Fragrance Section */}
      <div className="pattern-2-col">
        <Link href={tLinks('fragranceMain')} className="pattern-2-col-background" id="HP_fragrance">
          <div className="text-2-col">
            <p className="eyebrow">{tFragrance('fragranceEyebrow')}</p>
            <h2>{tFragrance('fragranceTitle')}</h2>
            <p>{tFragrance('fragranceDescription')}</p>
            <span className="btn-main">{tButton('shopNow')}</span>
          </div>
          <img
            src="/images/homepage/hp-fragrance.webp"
            alt={tFragrance('fragranceAlt')}
            className="image-2-col hp-fragrance"
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            width={650}
            height={457}
          />
        </Link>
      </div>
    </section>
  );
};

export default FragranceSection;
